import styled, { css } from "styled-components";
import { TableCellFlex } from "@8x8/oxygen-table";

const StyledTableCell = styled(TableCellFlex)`
  padding: 12px 8px;
  ${({ isEditingCell }) =>
    isEditingCell &&
    css`
      padding: 16px;
      margin: 0;
      overflow: visible;
    `}
  ${({ size }) => size && `flex-basis: ${size}px;`}
  background-color: inherit;
  align-items: center;

  // See class applied in src/react/components/CopyButton.jsx.
  .cell-copy-btn {
    display: none;
  }

  &:hover {
    .cell-copy-btn {
      display: block;
    }
  }
`;

export default StyledTableCell;
